import { IconArrowLeft } from '@iwoca/icons';
import { IwocaLogo } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';

import styles from './CreditCheckNav.module.css';

const HOMEPAGE_URL = 'https://www.iwoca.de';

// Deep links (e.g. from a marketing email) leave no history entry, so fall back
// to the homepage rather than a no-op back().
const goBack = () => {
  if (window.history.length > 1) {
    window.history.back();
  } else {
    window.location.assign(HOMEPAGE_URL);
  }
};

export const CreditCheckNav = () => {
  return (
    <nav className={styles.nav}>
      <IwocaLogo className={styles.logo} />
      <button type="button" className={styles.back} onClick={goBack}>
        <IconArrowLeft />
        <Trans>Back to homepage</Trans>
      </button>
    </nav>
  );
};
